import PageHeader from "../../components/layout/PageHeader.jsx";
import PreviousStepContainer from "../../components/common/PreviousStepContainer";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import SavedNotice from "../../components/common/SavedNotice";
import EffectManager from "../../components/impactStrategy/EffectManager.jsx";

/**
 * Route wrapper for Effecten. The CRUD lives in <EffectManager> (reused inline
 * in the TOC navigator); this page adds the chrome.
 */
const Effects = () => {
  return (
    <div className="main">
      <div className="main-container">
        <PageHeader
          heading={"Effecten"}
          description={`In deze stap benoem je de maatschappelijke effecten die je met je activiteiten wilt bereiken. Welke sociale effecten zijn niet telbaar maar wel de basis van het hogere doel? Bijvoorbeeld 'meer sociale contacten' of 'betere kennis eigen talent'. Elk effect heeft zijn eigen indicator(en), en kun je koppelen aan een of meerdere activiteiten.`}
          AI={true}
        />

        <EffectManager />

        <div className="impactstrategy-saved-and-nextstep-container">
          <SavedNotice />
          <div id="next-step-container">
            <PreviousStepContainer url={"Activities"} mainItem={"impactstrategy"} />
            <NextStepContainer url={"measurementplan"} mainItem={"measurementplan"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Effects;
